import { useEffect, useCallback } from 'react';
import { useNotificationContext } from '@frontend/notifications';
import { shell } from '@frontend/shell-utils';
import { useTopBarShallowStore } from '../store/use-top-bar-store';

interface Options {
  showForYouNotificationsTab: boolean;
  showGroupedForYouNotifications: boolean;
  isMobile: boolean;
}

export const useNotificationsState = ({ showForYouNotificationsTab, showGroupedForYouNotifications }: Options) => {
  const { unreadCount, unreadForYouCount, unreadGroupedForYouCount, setNotificationTrayIsOpen } =
    useNotificationContext();
  const {
    isNotificationsOpen: isOpen,
    isNotificationsHovering: isHovering,
    setNotificationsHovering,
    setNotificationsOpen,
  } = useTopBarShallowStore(
    'isNotificationsOpen',
    'isNotificationsHovering',
    'setNotificationsHovering',
    'setNotificationsOpen'
  );

  const getCount = useCallback(() => {
    if (showForYouNotificationsTab) {
      if (showGroupedForYouNotifications) return unreadGroupedForYouCount;
      return unreadForYouCount;
    }
    return unreadCount;
  }, [
    showForYouNotificationsTab,
    showGroupedForYouNotifications,
    unreadGroupedForYouCount,
    unreadForYouCount,
    unreadCount,
  ]);

  const count = getCount() || 0;

  useEffect(() => {
    if (shell.isShell) return;
    setNotificationTrayIsOpen(isOpen);
  }, [isOpen, setNotificationTrayIsOpen]);

  return {
    isNotificationsOpen: isOpen,
    setIsNotificationsOpen: setNotificationsOpen,
    isHovering,
    setIsHovering: setNotificationsHovering,
    count,
    showFullCount: isOpen || isHovering,
  };
};
